import { Block } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_QUOTE } from '../types';

/**
 * Create a quote block.
 */
export function create(nodes?: Block[]): Block {
    return Block.create({
        type: BLOCK_QUOTE,
        nodes: nodes || [createParagraph()],
    });
}
